<template>
  <div class="scope-config-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/menu/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内容管理</el-breadcrumb-item>
      <el-breadcrumb-item>科普宣教库</el-breadcrumb-item>
      <el-breadcrumb-item>宣教范围医院科室</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="query" size="small">
        <el-form-item label="医院">
          <el-input v-model="query.hospitalName" clearable placeholder="请输入医院名称" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="科室">
          <el-input v-model="query.departmentName" clearable placeholder="请输入科室名称" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.active" clearable placeholder="全部" class="status-select">
            <el-option label="启用" :value="true"></el-option>
            <el-option label="停用" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <div class="toolbar">
      <el-button type="primary" icon="el-icon-plus" @click="openCreateDialog">新增医院科室</el-button>
    </div>

    <el-table v-loading="loading" :data="tableData" border style="width: 100%">
      <el-table-column prop="hospitalName" label="医院" min-width="220"></el-table-column>
      <el-table-column prop="departmentName" label="科室" min-width="160"></el-table-column>
      <el-table-column label="医生账号" min-width="220">
        <template slot-scope="scope">
          <span v-if="scope.row.doctorPhones && scope.row.doctorPhones.length">
            <el-button
              v-for="phone in scope.row.doctorPhones"
              :key="phone"
              type="text"
              size="small"
              @click="openDoctorDialog(scope.row, phone)"
            >{{ phone }}</el-button>
          </span>
          <span v-else class="muted-text">暂无</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.active ? 'success' : 'info'" size="small">
            {{ scope.row.active ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="180">
        <template slot-scope="scope">{{ formatDate(scope.row.gmtCreate) }}</template>
      </el-table-column>
      <el-table-column label="更新时间" width="180">
        <template slot-scope="scope">{{ formatDate(scope.row.gmtModified) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="240" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openDoctorDialog(scope.row)">新增账号</el-button>
          <el-button type="text" size="small" @click="openRegisterDoctorDialog(scope.row)">注册账号</el-button>
          <el-button type="text" size="small" @click="toggleActive(scope.row)">
            {{ scope.row.active ? '停用' : '启用' }}
          </el-button>
          <el-button type="text" size="small" class="delete-button" @click="removeConfig(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="pagination.page"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <el-dialog title="新增医院科室" :visible.sync="createDialogVisible" width="440px" :close-on-click-modal="false">
      <el-form ref="createForm" :model="createForm" :rules="createRules" label-width="76px">
        <el-form-item label="医院" prop="hospitalName">
          <el-input v-model="createForm.hospitalName" maxlength="100" placeholder="请输入医院名称"></el-input>
        </el-form-item>
        <el-form-item label="科室" prop="departmentName">
          <el-input v-model="createForm.departmentName" maxlength="100" placeholder="请输入科室名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="createDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitCreate">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="doctorDialogTitle"
      :visible.sync="doctorDialogVisible"
      width="680px"
      :close-on-click-modal="false"
    >
      <el-form ref="doctorForm" :model="doctorForm" :rules="doctorRules" label-width="90px">
        <el-form-item label="医院科室">
          <span>{{ doctorForm.hospitalName }} - {{ doctorForm.departmentName }}</span>
        </el-form-item>
        <el-form-item label="医生手机号" prop="doctorPhone">
          <el-input v-model="doctorForm.doctorPhone" placeholder="请输入已注册的医生手机号" @input="handleDoctorPhoneInput" @keyup.enter.native="checkDoctorAccount">
            <el-button slot="append" :loading="doctorChecking" @click="checkDoctorAccount">检查账号</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="注册信息">
          <span v-if="doctorInfo">
            {{ doctorInfo.realname || '未填写姓名' }}
            <el-tag type="success" size="mini">已注册</el-tag>
          </span>
          <span v-else class="muted-text">请输入手机号并检查</span>
        </el-form-item>
        <el-form-item label="关联会话">
          <el-table :data="doctorConversations" border size="small" max-height="240">
            <el-table-column prop="id" label="会话 ID" min-width="220"></el-table-column>
            <el-table-column prop="patientRealname" label="患者姓名" min-width="140">
              <template slot-scope="scope">{{ scope.row.patientRealname || '未填写姓名' }}</template>
            </el-table-column>
            <el-table-column v-if="!doctorConversations.length" label="暂无会话">
              <span class="muted-text">暂无关联会话</span>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          v-if="doctorInfo"
          type="warning"
          :loading="bedConversationSubmitting"
          @click="initializeBedConversations"
        >初始化病床号会话</el-button>
        <el-button @click="doctorDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="doctorSubmitting" @click="submitDoctorEdit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="注册医生账号"
      :visible.sync="registerDoctorDialogVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="registerDoctorForm"
        :model="registerDoctorForm"
        :rules="registerDoctorRules"
        label-width="100px"
      >
        <el-form-item label="医院科室">
          <span>{{ registerDoctorForm.hospitalName }} - {{ registerDoctorForm.departmentName }}</span>
        </el-form-item>
        <el-form-item label="手机号" prop="doctorPhone">
          <el-input v-model="registerDoctorForm.doctorPhone" maxlength="11" placeholder="请输入医生手机号"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="realname">
          <el-input v-model="registerDoctorForm.realname" maxlength="50" placeholder="请输入医生姓名"></el-input>
        </el-form-item>
        <el-form-item label="默认密码">
          <span>123456</span>
        </el-form-item>
        <el-form-item label="邀请码">
          <span>1758</span>
        </el-form-item>
        <el-form-item label="医院 ID">
          <span>1</span>
        </el-form-item>
        <el-form-item label="性别 / 年龄">
          <span>男 / 0 岁</span>
        </el-form-item>
        <el-form-item label="执业信息">
          <span>{{ registerDoctorForm.hospitalName }} / 机器人 / 1 年</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="registerDoctorDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="registerDoctorSubmitting" @click="submitDoctorRegister">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ArticleScopeHospitalDepartment',
  data () {
    return {
      loading: false,
      submitting: false,
      createDialogVisible: false,
      doctorSubmitting: false,
      doctorChecking: false,
      bedConversationSubmitting: false,
      doctorDialogVisible: false,
      registerDoctorDialogVisible: false,
      registerDoctorSubmitting: false,
      doctorDialogTitle: '医生账号详情',
      tableData: [],
      query: {
        hospitalName: '',
        departmentName: '',
        active: null
      },
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      createForm: {
        hospitalName: '',
        departmentName: ''
      },
      createRules: {
        hospitalName: [{ required: true, message: '请输入医院名称', trigger: 'blur' }],
        departmentName: [{ required: true, message: '请输入科室名称', trigger: 'blur' }]
      },
      doctorForm: {
        hospitalName: '',
        departmentName: '',
        originalDoctorPhone: '',
        doctorPhone: ''
      },
      doctorRules: {
        doctorPhone: [
          { required: true, message: '请输入医生手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      },
      doctorInfo: null,
      doctorConversations: [],
      registerDoctorForm: {
        doctorPhone: '',
        realname: '',
        hospitalName: '',
        departmentName: ''
      },
      registerDoctorRules: {
        doctorPhone: [
          { required: true, message: '请输入医生手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        realname: [
          { required: true, message: '请输入医生姓名', trigger: 'blur' },
          { whitespace: true, message: '请输入医生姓名', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.loadList()
  },
  methods: {
    async loadList () {
      this.loading = true
      const params = {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      }
      if (this.query.hospitalName.trim()) params.hospitalName = this.query.hospitalName.trim()
      if (this.query.departmentName.trim()) params.departmentName = this.query.departmentName.trim()
      if (this.query.active !== null) params.active = this.query.active
      try {
        const { data: resp } = await this.$http.get('doctor_hospital_department/manage/list', { params })
        if (resp.code !== 200) {
          this.$message.error(resp.message || '加载医院科室失败')
          return
        }
        this.tableData = resp.data.list || []
        this.pagination.total = resp.data.total || 0
        this.pagination.page = resp.data.page || 1
        this.pagination.pageSize = resp.data.pageSize || 20
      } finally {
        this.loading = false
      }
    },
    handleSearch () {
      this.pagination.page = 1
      this.loadList()
    },
    resetQuery () {
      this.query = {
        hospitalName: '',
        departmentName: '',
        active: null
      }
      this.handleSearch()
    },
    handlePageChange (page) {
      this.pagination.page = page
      this.loadList()
    },
    openCreateDialog () {
      this.createForm = {
        hospitalName: '',
        departmentName: ''
      }
      this.createDialogVisible = true
      this.$nextTick(() => this.$refs.createForm && this.$refs.createForm.clearValidate())
    },
    openDoctorDialog (row, doctorPhone = '') {
      this.doctorForm = {
        hospitalName: row.hospitalName,
        departmentName: row.departmentName,
        originalDoctorPhone: doctorPhone,
        doctorPhone
      }
      this.doctorInfo = null
      this.doctorConversations = []
      this.doctorDialogVisible = true
      this.$nextTick(() => this.$refs.doctorForm && this.$refs.doctorForm.clearValidate())
      if (doctorPhone) this.checkDoctorAccount()
    },
    openRegisterDoctorDialog (row) {
      this.registerDoctorForm = {
        doctorPhone: '',
        realname: '',
        hospitalName: row.hospitalName,
        departmentName: row.departmentName
      }
      this.registerDoctorDialogVisible = true
      this.$nextTick(() => this.$refs.registerDoctorForm && this.$refs.registerDoctorForm.clearValidate())
    },
    submitDoctorRegister () {
      this.$refs.registerDoctorForm.validate(async valid => {
        if (!valid || this.registerDoctorSubmitting) return
        this.registerDoctorSubmitting = true
        try {
          const { data: resp } = await this.$http.post(
            'doctor_hospital_department/manage/register-doctor',
            null,
            {
              params: {
                doctorPhone: this.registerDoctorForm.doctorPhone.trim(),
                realname: this.registerDoctorForm.realname.trim(),
                hospitalName: this.registerDoctorForm.hospitalName,
                departmentName: this.registerDoctorForm.departmentName
              }
            }
          )
          if (resp.code !== 200) {
            this.$message.error(resp.message || '医生账号注册失败')
            return
          }
          this.$message.success('医生账号注册成功')
          this.registerDoctorDialogVisible = false
          this.loadList()
        } finally {
          this.registerDoctorSubmitting = false
        }
      })
    },
    handleDoctorPhoneInput () {
      this.doctorInfo = null
      this.doctorConversations = []
    },
    async checkDoctorAccount () {
      const doctorPhone = this.doctorForm.doctorPhone.trim()
      if (!/^1\d{10}$/.test(doctorPhone)) {
        this.doctorInfo = null
        this.doctorConversations = []
        this.$message.warning('请输入正确的手机号')
        return false
      }
      this.doctorChecking = true
      try {
        const { data: resp } = await this.$http.get('doctor_hospital_department/manage/doctor-detail', {
          params: { doctorPhone }
        })
        if (resp.code !== 200) {
          this.doctorInfo = null
          this.doctorConversations = []
          this.$message.error(resp.message || '手机号未注册')
          return false
        }
        this.doctorInfo = resp.data
        this.doctorConversations = resp.data.conversations || []
        return true
      } finally {
        this.doctorChecking = false
      }
    },
    async submitDoctorEdit () {
      this.$refs.doctorForm.validate(async valid => {
        if (!valid) return
        const doctorPhone = this.doctorForm.doctorPhone.trim()
        const checked = this.doctorInfo && this.doctorInfo.doctorPhone === doctorPhone
        if (!checked && !(await this.checkDoctorAccount())) return
        this.doctorSubmitting = true
        try {
          if (this.doctorForm.originalDoctorPhone && this.doctorForm.originalDoctorPhone !== doctorPhone) {
            const { data: deleteResp } = await this.$http.delete('doctor_hospital_department/delete', {
              params: { doctorPhone: this.doctorForm.originalDoctorPhone }
            })
            if (deleteResp.code !== 200) {
              this.$message.error(deleteResp.message || '原医生账号删除失败')
              return
            }
          }
          if (!this.doctorForm.originalDoctorPhone || this.doctorForm.originalDoctorPhone !== doctorPhone) {
            const { data: saveResp } = await this.$http.post('doctor_hospital_department/save', null, {
              params: {
                doctorPhone,
                hospitalName: this.doctorForm.hospitalName,
                departmentName: this.doctorForm.departmentName
              }
            })
            if (saveResp.code !== 200) {
              this.$message.error(saveResp.message || '医生账号保存失败')
              return
            }
          }
          this.$message.success('医生账号保存成功')
          this.doctorDialogVisible = false
          this.loadList()
        } finally {
          this.doctorSubmitting = false
        }
      })
    },
    async initializeBedConversations () {
      try {
        await this.$confirm(
          '将为当前医生初始化 Excel 中的病床号会话，已存在的会话会自动跳过。确认继续吗？',
          '初始化病床号会话',
          { type: 'warning' }
        )
        this.bedConversationSubmitting = true
        const { data: resp } = await this.$http.post(
          'doctor_hospital_department/manage/initialize-bed-conversations',
          null,
          { params: { doctorPhone: this.doctorForm.doctorPhone.trim() } }
        )
        if (resp.code !== 200) {
          this.$message.error(resp.message || '初始化病床号会话失败')
          return
        }
        this.$message.success(
          `初始化完成，新建 ${resp.data.createdCount} 条，跳过 ${resp.data.skippedCount} 条`
        )
        await this.checkDoctorAccount()
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') {
          this.$message.error('初始化病床号会话失败')
        }
      } finally {
        this.bedConversationSubmitting = false
      }
    },
    submitCreate () {
      this.$refs.createForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          const { data: resp } = await this.$http.post('doctor_hospital_department/manage/create', null, {
            params: {
              hospitalName: this.createForm.hospitalName.trim(),
              departmentName: this.createForm.departmentName.trim()
            }
          })
          if (resp.code !== 200) {
            this.$message.error(resp.message || '新增失败')
            return
          }
          this.$message.success('新增成功')
          this.createDialogVisible = false
          this.handleSearch()
        } finally {
          this.submitting = false
        }
      })
    },
    async toggleActive (row) {
      const active = !row.active
      const action = active ? '启用' : '停用'
      try {
        await this.$confirm(`确认${action}“${row.hospitalName} - ${row.departmentName}”吗？`, '提示', {
          type: 'warning'
        })
        const { data: resp } = await this.$http.put('doctor_hospital_department/manage/active', null, {
          params: { id: row.id, active }
        })
        if (resp.code !== 200) {
          this.$message.error(resp.message || `${action}失败`)
          return
        }
        this.$message.success(`${action}成功`)
        this.loadList()
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') {
          this.$message.error('操作失败')
        }
      }
    },
    async removeConfig (row) {
      try {
        await this.$confirm(`确认删除“${row.hospitalName} - ${row.departmentName}”吗？`, '提示', {
          type: 'warning'
        })
        const { data: resp } = await this.$http.delete('doctor_hospital_department/manage/delete', {
          params: { id: row.id }
        })
        if (resp.code !== 200) {
          this.$message.error(resp.message || '删除失败')
          return
        }
        this.$message.success('删除成功')
        if (this.tableData.length === 1 && this.pagination.page > 1) {
          this.pagination.page--
        }
        this.loadList()
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') {
          this.$message.error('操作失败')
        }
      }
    },
    formatDate (value) {
      if (!value) return '-'
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return value
      const pad = number => String(number).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    }
  }
}
</script>

<style scoped>
.scope-config-page {
  padding: 20px;
}

.filter-card {
  margin-top: 20px;
}

.status-select {
  width: 120px;
}

.toolbar {
  display: flex;
  justify-content: flex-end;
  margin: 16px 0;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.delete-button {
  color: #f56c6c;
}

.muted-text {
  color: #909399;
}
</style>
